import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

import { SocialComponent } from './social.component';
import { PipesModule } from '../../pipes/pipes.module';
import { TranslateModule } from '@ngx-translate/core';
import { SocialV2Component } from './social-v2.component';

@NgModule({
  declarations: [SocialComponent, SocialV2Component],
  exports: [SocialComponent, SocialV2Component],
  imports: [CommonModule, PipesModule, NzToolTipModule, TranslateModule],
})
export class SocialModule {}
